import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

const ReCaptcha = ({
  onChange,
  type = "image",
  theme = "light",
  size = "normal",
  className,
  style,
  id,
}) => {
  return (
    <ReCAPTCHA
      id={id}
      style={style}
      className={className}
      sitekey={process.env.NEXT_PUBLIC_RECAPTCHA}
      onChange={onChange}
      type={type}
      theme={theme}
      size={size}
      badge="inline"
    />
  );
};

export default ReCaptcha;
